// Purple theme
const purple = {
  id: 'purple',
  name: 'Violetti',
  price: 25,
  main: '#a438b6',
  light: '#ba68c8',
  dark: '#7b1fa2',
  bg: '#f3e5f5',
  darkBg: '#231a2d',
  isSuper: false,
  surfaces: {
    // Light mode
    lightBg: '#e8d0ed',
    lightPaper: '#f3e5f5',
    lightContainer: '#f3e5f5',
    lightOnSurface: '#1a1a2e',
    lightOnSurfaceVariant: '#5c4066',
    lightOutline: '#8e60a5',
    // Dark mode
    containerLowest: '#1a1225',
    containerLow: '#0a0510',
    container: '#1a1225',
    containerHigh: '#342644',
    containerHighest: '#3e2f50',
    bright: '#4a3860',
    onSurface: '#f3e0ff',
    onSurfaceVariant: '#c8a0d8',
    outline: '#8e60a5',
    outlineVariant: '#5a3570',
    // Button colors — primary
    primaryContainer: '#ba68c8',
    onPrimaryContainer: '#2e003a',
    // Button colors — secondary (outlined)
    secondaryContainer: '#3d1a50',
    onSecondaryContainer: '#d4a0e8',
    // Button colors — secondary (filled)
    secondary: '#ce93d8',
    onSecondary: '#3e003e',
    secondaryLight: '#7b1fa2',
    onSecondaryLight: '#ffffff',
    // Button colors — inverse
    inverseSurface: '#f3e5f5',
    onInverseSurface: '#231a2d',
    inverseSurfaceLight: '#231a2d',
    onInverseSurfaceLight: '#f3e0ff',
    // Button colors — label/text
    labelColor: '#ba68c8',
    labelColorLight: '#7b1fa2',
    // Status colors
    success: '#4caf50',
    successLight: '#81c784',
    successDark: '#2e7d32',
    warning: '#ed6c02',
    warningLight: '#ff9800',
    warningDark: '#e65100',
    error: '#ef5350',
    errorLight: '#ff7961',
    errorDark: '#c62828',
  },
};

export default purple;
